//#region src/kiosk_availability.ts
var KioskAvailability = /* @__PURE__ */ function(KioskAvailability) {
	KioskAvailability[KioskAvailability["ON"] = 0] = "ON";
	KioskAvailability[KioskAvailability["OFF_UNTIL_NEXT"] = 1] = "OFF_UNTIL_NEXT";
	KioskAvailability[KioskAvailability["OFF_INDEFINITELY"] = 2] = "OFF_INDEFINITELY";
	return KioskAvailability;
}(KioskAvailability || {});
//#endregion
export { KioskAvailability };

//# sourceMappingURL=kiosk_availability.js.map